const imgTeamGoodsPackageCards = "./assets/figma/06744399-888e-4094-a77f-3c9a1652fb48.png";
const img3 = "./assets/figma/67472046-c77c-4ef7-bb78-1bb6338dc39a.png";
const img2026923382 = "./assets/figma/28434674-e6be-4dd7-bed7-6a17cba426a6.png";
const img2026923373 = "./assets/figma/0055b262-7091-4522-ae89-23e7c6b7377a.png";
const imgRectangle245 = "./assets/figma/0470d51d-5596-4e3f-9712-8c5cae2ec5cf.png";
const img11791 = "./assets/figma/63ebc491-8f3a-43d2-b84e-ccf370097cf9.png";
const imgChatGptImage20269130514461 = "./assets/figma/d2cd56db-db09-4a2b-934d-57a7fdb2cae9.png";
const img131 = "./assets/figma/119c16f9-324c-48a6-a504-fcdd33a809de.png";
const img141 = "./assets/figma/cb1300e8-97e9-4966-92e0-ead7416e9478.png";
const img151 = "./assets/figma/67d5a3d6-592d-4e35-9808-10aa248d6696.png";
const imgLine21 = "./assets/figma/024cae05-40d5-40cd-8187-3cfbbb55f6fe.svg";
const img1 = "./assets/figma/12bba834-9dfb-408a-831d-4e0f805933eb.svg";
const imgLine25 = "./assets/figma/05a65c31-9eb5-4b95-a7ed-46d18eb9cd91.svg";
const imgLine26 = "./assets/figma/004e04b2-2999-4bf9-a0ef-7d979948c643.svg";
const imgLine27 = "./assets/figma/05a65c31-9eb5-4b95-a7ed-46d18eb9cd91.svg";
const imgRectangle243 = "./assets/figma/0dfb52b6-ae5c-4986-8e59-80bb7d314ca8.svg";
const imgRectangle246 = "./assets/figma/0f75945d-c052-4259-ba44-5c51f8242788.svg";
const imgClose = "./assets/figma/126d0178-fb8f-4298-97a5-6e9219784749.svg";

export default function TeamGoodsPackageCards() {
  return (
    <div className="s0 s1" data-node-id="875:244" data-name="TEAM_GOODS/PACKAGE/CARDS">
      <div aria-hidden className="s2 s3 s4">
        <div className="s2 s5 s3" />
        <div className="s2 s3 s6">
          <img alt="" className="s2 s7 s321 s9 s10 s322" src={imgTeamGoodsPackageCards} />
        </div>
      </div>
      <div className="s2 s12 s13 s14 s15" data-node-id="875:247" data-name="image 14" />
      <div className="s2 s16 s17 s18 s19 s20 s323 s22" data-node-id="875:248">
        <div className="s23 s16 s17 s24 s25 s26 s27 s0 s28 s29 s30" data-node-id="875:249">
          <p className="s31 s32 s0 s28 s33 s34" data-node-id="875:250">
            PROJECT OVERVIEW
          </p>
          <p className="s35 s39 s0 s28 s37 s34" data-node-id="875:251">
            DOMINO TILES · 30 × 48 × 5 MM · 15
            <br aria-hidden />
            GAME BOARD · 550 × 550 MM · 1<br aria-hidden />
            CARDS · 63 × 88 MM · 20
            <br aria-hidden />
            INSTRUCTION PANEL
          </p>
        </div>
        <div className="s17 s41 s18 s42 s0 s28 s43" data-node-id="875:252">
          <div className="s44 s45">
            <div className="s46 s0 s47">
              <div className="s2 s48">
                <img alt="" className="s49 s9 s1" src={imgLine21} />
              </div>
            </div>
          </div>
        </div>
        <div className="s23 s16 s17 s24 s25 s26 s27 s0 s28 s29 s50" data-node-id="875:253">
          <p className="s31 s32 s0 s28 s33 s34" data-node-id="875:254">
            MEMBERS
          </p>
          <p className="s35 s39 s0 s28 s37 s34" data-node-id="875:255">
            신지수
            <br aria-hidden />
            윤현서
            <br aria-hidden />
            지윤주
            <br aria-hidden />
            홍민지
          </p>
        </div>
      </div>
      <p className="s23 s2 s51 s32 s52 s27 s29 s33 s324 s54" data-node-id="875:256">
        LET THE IDEAS ROLL, PLAY THE LAB
      </p>
      <div className="s23 s2 s16 s17 s24 s25 s26 s55 s27 s29 s325 s57" data-node-id="875:257">
        <p className="s31 s32 s0 s28 s58 s59" data-node-id="875:258">
          ABOUT
        </p>
        <div className="s35 s36 s0 s28 s37 s59 s38" data-node-id="875:259">
          <p className="s39 s40">{`패키지/굿즈팀은 원하는 결과에 도달하기 위해 AI를 선택하고 조합하는 과정을 도미노 보드게임 패키지로 `}</p>
          <p className="s39 s40">{`시각화했다. 2~4명의 플레이어는 게임 시작 시 결과 구슬 카드를 뽑아 목표를 정하고 AI 도미노를 나누어 가진다. `}</p>
          <p className="s39 s40">{`이후 카드에 제시된 조건에 맞는 도미노를 골라 순서대로 연결하며 각자의 AI 파이프라인을 구성한다. `}</p>
          <p className="s39 s40">{`조건을 가장 먼저 충족해 도미노 라인을 완성한 플레이어가 승리하고, 완성된 도미노를 직접 쓰러뜨리며 AI의 `}</p>
          <p className="s39">선택과 조합에서 결과 도출까지 이어지는 과정을 놀이로 경험하도록 제작했다.</p>
        </div>
      </div>
      <p className="s23 s2 s31 s32 s326 s27 s29 s61 s62 s54" data-node-id="875:260">
        GOODS/PACKAGE
      </p>
      <div className="s2 s17 s327 s18 s42 s328 s325 s329" data-node-id="875:261">
        <div className="s330 s44 s331">
          <div className="s327 s0 s329" data-name="패키지팀 3">
            <img alt="" className="s2 s3 s9 s105 s4 s1" src={img3} />
          </div>
        </div>
      </div>
      <div className="s2 s16 s17 s24 s332 s26 s20 s333 s334" data-node-id="875:262">
        <p className="s23 s31 s32 s27 s0 s28 s29 s64 s34" data-node-id="875:263">
          WORK
        </p>
        <div className="s16 s17 s18 s19 s36 s0 s28 s34" data-node-id="875:264" data-name="TEAM_GOODS/PACKAGE_WORK">
          <div className="s335 s336 s337 s338 s0 s28" data-node-id="875:265">
            <div className="s192 s335 s336 s337 s339 s340 s338 s0 s198" data-node-id="875:266">
              <div className="s192 s69 s339 s340 s0 s70 s198 s71" data-node-id="875:267" data-name="이미지 2026. 9. 2. 오후 3.38 2">
                <div className="s2 s3 s6 s4 s70">
                  <img alt="" className="s2 s341 s342 s9 s10 s343" src={img2026923382} />
                </div>
              </div>
              <div className="s76 s192 s344 s69 s339 s340 s0 s70 s198 s78 s79 s71" data-node-id="875:268" />
            </div>
            <div className="s80 s192 s81 s69 s339 s340 s82 s0 s70 s198 s71" data-node-id="875:269" />
            <p className="s23 s192 s31 s32 s345 s346 s27 s0 s198 s29 s33 s85 s54" data-node-id="875:270">
              DOMINO TILES
            </p>
          </div>
          <div className="s335 s336 s337 s338 s0 s28" data-node-id="875:271">
            <div className="s192 s17 s69 s18 s42 s339 s340 s0 s198 s71" data-node-id="875:272">
              <div className="s330 s44 s331">
                <div className="s69 s0 s70 s71" data-name="패키지팀 4">
                  <img alt="" className="s2 s3 s9 s105 s4 s70 s1" src={img3} />
                </div>
              </div>
            </div>
            <div className="s76 s192 s344 s69 s339 s340 s0 s70 s198 s78 s79 s71" data-node-id="875:273" />
            <div className="s80 s192 s81 s69 s339 s340 s82 s0 s70 s198 s71" data-node-id="875:274" />
            <div className="s23 s192 s31 s347 s346 s27 s0 s198 s29 s33 s85 s54" data-node-id="875:275">
              <p className="s94 s40">GAME BOARD</p>
              <p className="s94">INSTRUCTION PANEL</p>
            </div>
          </div>
          <div className="s335 s336 s337 s338 s0 s28" data-node-id="875:276">
            <div className="s192 s69 s339 s340 s0 s70 s198 s348 s71" data-node-id="875:277" data-name="이미지 2026. 9. 2. 오후 3.37 3">
              <div className="s2 s3 s6 s4 s70">
                <img alt="" className="s2 s349 s350 s9 s10 s351" src={img2026923373} />
              </div>
            </div>
            <div className="s76 s192 s77 s69 s339 s340 s0 s70 s198 s79 s71" data-node-id="875:278" />
            <div className="s80 s192 s81 s69 s339 s340 s82 s0 s70 s198 s71" data-node-id="875:279" />
            <p className="s23 s192 s31 s94 s352 s346 s27 s0 s198 s29 s33 s85 s54" data-node-id="875:280">
              CARDS
            </p>
          </div>
        </div>
      </div>
      <div className="s2 s102 s103 s10 s104" data-node-id="875:281">
        <img alt="" className="s2 s3 s9 s105 s4 s1" src={imgRectangle245} />
      </div>
      <div className="s106 s2 s16 s17 s18 s19 s107 s108 s109" data-node-id="875:282" data-name="navigationbar">
        <div className="s16 s17 s110 s26 s0 s28" data-node-id="875:283">
          <div className="s111 s0 s28 s112" data-node-id="875:284" data-name="_레이어_1">
            <img alt="" className="s2 s49 s3 s9 s1" src={img1} />
          </div>
          <p className="s23 s31 s113 s32 s27 s0 s28 s29 s114 s115 s116" data-node-id="875:289">
            DING AI LAB
          </p>
        </div>
        <div className="s16 s17 s117 s18 s0 s28" data-node-id="875:290">
          <div className="s16 s17 s24 s118 s18 s0 s28 s119" data-node-id="875:291">
            <p className="s23 s120 s121 s32 s27 s0 s28 s29 s122 s115 s54" data-node-id="875:292">
              PROJECT
            </p>
            <div className="s46 s0 s28 s34" data-node-id="875:293">
              <img alt="" className="s2 s49 s3 s9 s1" src={imgLine25} />
            </div>
          </div>
          <div className="s16 s17 s24 s118 s18 s0 s28 s123" data-node-id="875:294">
            <p className="s23 s120 s121 s32 s27 s0 s28 s29 s122 s115 s54" data-node-id="875:295">
              TEAM
            </p>
            <div className="s46 s0 s28 s34" data-node-id="875:296">
              <div className="s2 s48">
                <img alt="" className="s49 s9 s1" src={imgLine26} />
              </div>
            </div>
          </div>
          <div className="s16 s17 s24 s118 s18 s0 s28 s124" data-node-id="875:297">
            <p className="s23 s120 s121 s32 s27 s0 s28 s29 s122 s115 s54" data-node-id="875:298">
              ABOUT
            </p>
            <div className="s46 s0 s28 s34" data-node-id="875:299">
              <img alt="" className="s2 s49 s3 s9 s1" src={imgLine27} />
            </div>
          </div>
        </div>
      </div>
      <div className="s2 s353 s354 s10 s104" data-node-id="875:300">
        <div className="s2 s355">
          <img alt="" className="s49 s9 s1" src={imgRectangle243} />
        </div>
      </div>
      <div className="s106 s2 s128 s126 s10 s104" data-node-id="875:497">
        <div className="s2 s129">
          <img alt="" className="s49 s9 s1" src={imgRectangle246} />
        </div>
      </div>
      <div className="s106 s2 s67 s126 s356" data-node-id="875:329">
        <div className="s2 s5 s357 s153 s156 s157 s356 s158" data-node-id="863:5622" />
        <p className="s23 s2 s31 s32 s358 s27 s29 s160 s359 s54" data-node-id="863:5623">
          CARDS
        </p>
        <p className="s23 s2 s31 s32 s360 s27 s29 s137 s361 s54" data-node-id="863:5624">
          CARDS DESIGN
        </p>
        <div className="s2 s362 s189 s363 s364" data-node-id="863:5632" data-name="이미지 1179 1">
          <img alt="" className="s2 s3 s9 s105 s4 s1" src={img11791} />
        </div>
        <div className="s2 s365 s366 s367 s368" data-node-id="863:5633" data-name="ChatGPT Image 2026년 9월 13일 오후 05_14_46 1">
          <div className="s2 s3 s6 s4">
            <img alt="" className="s2 s7 s369 s9 s10 s370" src={imgChatGptImage20269130514461} />
          </div>
        </div>
        <div className="s106 s2 s67 s256 s371" data-node-id="863:5658">
          <div className="s106 s2 s372 s256 s165 s4 s145 s146 s371 s373" data-node-id="863:5659">
            <div aria-hidden className="s2 s147 s3 s145" />
            <div className="s2 s3 s150 s151" />
          </div>
          <div className="s23 s2 s16 s17 s24 s167 s374 s26 s375 s27 s29 s376 s377" data-node-id="863:5660">
            <div className="s16 s17 s24 s172 s26 s0 s28 s34" data-node-id="863:5661">
              <p className="s31 s32 s0 s28 s173 s34" data-node-id="863:5662">
                Prompt
              </p>
              <div className="s35 s36 s0 s28 s174 s34" data-node-id="863:5663">
                <p className="s175 s40">STRICT COLOR DISTRIBUTION: White 20% + Blue20% + Pink20%</p>
                <p className="s175 s40">+ Gray20% + Mint20%</p>
                <p className="s175 s40">A single perfectly spherical transparent crystal glass orb centered on a pure #FFFFFF seamless studio background. The sphere must have an extremely smooth, flawless, perfectly polished surface with high transparency, realistic optical refraction, internal light transmission, and a premium crystal-glass appearance.</p>
                <p className="s175 s40">Inside the transparent sphere, use only four colors in the following strict visual proportions:</p>
                <p className="s175 s40">White + Blue + Pink + Gray + Mint must each occupy approximately equal 20% areas.</p>
                <p className="s175 s40">The four colors should appear as large, soft translucent color volumes suspended within the clear glass, smoothly flowing into adjacent areas while remaining visually distinguishable. Allow subtle optical overlap caused only by glass transparency and refraction, but preserve the original White + Blue + Pink + Gray + Mint colors without introducing intermediate or additional hues.</p>
                <p className="s175 s40">keep the colors clean, sort, luminous, and signty translucent rather than opaque.</p>
                <p className="s175 s40">No additional colors anywhere in the sphere.</p>
                <p className="s175 s40">Use a clean premium optical-glass material with a perfectly smooth spherical silhouette. Create a clearly visible transparent</p>
                <p className="s175 s40">outer dacs shell with a siontv micker dass rim suore darker refraction around selected edges, realistic internal refraction, and clean light bending through the sphere.</p>
                <p className="s175 s40">Add large, smooth, controlled specular highlights across the glass surface, includina several soft rectangular studio-liaht reflections along the upper-left and upper portions of the sphere. Add subtle curved highlights following the spherical contour and small concentrated highlights around selected edges. The highlights should ennance the transparent glass appearance without obscuring the internal colors.</p>
                <p className="s175">The glass must look clean, solid, smooth, and optically precise, not liquid or irregular. Keep all reflections broad, polished, controlled, and physically believable.</p>
              </div>
            </div>
            <div className="s16 s17 s24 s172 s26 s0 s28 s34" data-node-id="863:5664">
              <p className="s31 s32 s0 s28 s173 s34" data-node-id="863:5665">
                AI TOOLS
              </p>
              <p className="s35 s175 s0 s28 s174 s34" data-node-id="863:5666">
                Chat GPT
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="s2 s16 s17 s24 s378 s26 s20 s132 s133" data-node-id="875:314" data-name="PROJECT_CATEGORY_TABS_GOODS/PACKAGE">
        <p className="s23 s31 s32 s379 s27 s0 s28 s58 s138 s380" data-node-id="875:315">
          GOODS/PACKAGE
        </p>
        <div className="s16 s17 s139 s18 s0 s28 s140" data-node-id="875:331" data-name="PROJECT_CATEGORY_TABS_GOODS/PACKAGE">
          <a className="s16 s141 s17 s18 s42 s142 s143 s144 s0 s145 s146 s28" data-node-id="875:332" data-name="TAB_DOMINO_TILES">
            <div aria-hidden className="s2 s147 s3 s4 s145" />
            <p className="s23 s31 s32 s27 s0 s28 s148 s149 s138 s54" data-node-id="875:333">
              DOMINO TILES
            </p>
            <div className="s2 s3 s4 s150 s151" />
          </a>
          <a className="s16 s141 s17 s18 s42 s142 s143 s144 s0 s145 s146 s28" data-node-id="875:334" data-name="TAB_GAMEBOARD">
            <div aria-hidden className="s2 s147 s3 s4 s145" />
            <p className="s23 s31 s32 s27 s0 s28 s148 s149 s138 s54" data-node-id="875:335">
              GAME BOARD
            </p>
            <div className="s2 s3 s4 s150 s151" />
          </a>
          <div className="s16 s81 s17 s18 s42 s142 s143 s144 s0 s145 s28" data-node-id="875:336" data-name="TAB_CARDS">
            <div aria-hidden className="s2 s152 s3 s4 s145" />
            <p className="s23 s31 s32 s27 s0 s28 s29 s148 s54" data-node-id="875:337">
              CARDS
            </p>
            <div className="s2 s3 s4 s150 s151" />
          </div>
        </div>
      </div>
      <button className="s2 s49 s141 s211 s212 s213" data-node-id="891:158" data-name="close">
        <img alt="" className="s2 s49 s3 s9 s1" src={imgClose} />
      </button>
      <div className="s2 s381 s382 s383" data-node-id="1032:523" data-name="구슬 채도조정-13 1">
        <img alt="" className="s2 s3 s9 s105 s4 s1" src={img131} />
      </div>
      <div className="s2 s384 s385 s386" data-node-id="1032:524" data-name="구슬 채도조정-14 1">
        <img alt="" className="s2 s3 s9 s105 s4 s1" src={img141} />
      </div>
      <div className="s2 s387 s388 s389" data-node-id="1032:525" data-name="구슬 채도조정-15 1">
        <img alt="" className="s2 s3 s9 s105 s4 s1" src={img151} />
      </div>
    </div>
  );
}